export default __webpack_public_path__ + "static/media/adv1.af25978e.jpg";